import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'valueById', standalone: true })
export class ValueByIdPipe implements PipeTransform {
    transform(arrey: any[], id: number, field: string): any {
        return this.getValue(arrey, id, field);
    }

    getValue(arrey: any[], id: number, field: string) {
        if (!arrey || arrey.length <= 0) {
            return '';
        }

        const res = arrey.filter((val) => {
            return val.id === id;
        })[0];
        if (res && field) {
            return res[field];
        }

        return res ? res.text || res.value || res.name : '';
    }
}
